import { createContext } from 'react';

/**
 * This context is used to determine if the user is logged in.
 * @example
 * const isLoggedIn = useContext(LoggedInContext);
 */
const LoggedInContext = createContext(null);
export default LoggedInContext;